import { useEffect, useState } from 'react';
import data from './Data.json';
import { Link, useNavigate } from 'react-router-dom';
import { axiosInstance } from '../../axios';
import Info from './information/Info';
import Analytics from '../analytics/Analytics';
import './Summary.css';
import { AbmAIAnimation, AudioAIAnimation, ComingSoonAnimation } from '../LottieAnimationItems/LAnimations';
// import Instruction from '../instruction/Instruction';


function Summary({ closed, setClosed, showSuccessfullyDeleteSummary, showErrorDeleteSummary, showWarning, showSuccess }) {
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [retryCount, setRetryCount] = useState(0);
  const MAX_RETRY_LIMIT = 10; // Max number of retry attempts
  const RETRY_DELAY = 8000;


  const [summaryDataFetch, setSummaryDataFetch] = useState([]);
  const [analytics, setAnalytics] = useState([0, 0]);
  const [loading, setLoading] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [filterOption, setFilterOption] = useState('all');
  const [searchInput, setSearchInput] = useState('');
  const [checkButtonState, setCheckButtonState] = useState(true);
  const [removeModalShow, setRemoveModalShow] = useState(true);
  const [activeCount, setActiveCount] = useState(0);
  const navigate = useNavigate();


  const removeData = async (id) => {
    setLoading(true);
    try {
      const response = await axiosInstance.delete(`solo_audio/${id}/`);
      // console.log(response?.status);
      if (response?.status === 200) {
        setLoading(false);
        // console.log(response?.data);
        // Handle successful response, e.g., set some state.
      } else {
        setLoading(false);
      }
    } catch (error) {
      console.log('error2');
      showWarning('해당 음성 파일 처리 중입니다.')
      setLoading(false);
    }
  }


  const downloadDocuments = async () => {
    try {
      // Prepare the POST request data
      const postData = { audio_ids: selectedItems };

      const response = await axiosInstance.post('download_documents/', postData, {
        responseType: 'blob', // To receive the file data as a Blob
      });

      // Extract filename from the custom header
      const contentDisposition = response.headers['x-suggested-filename'];
      let filename = 'default_filename.zip'; // Default filename
      if (contentDisposition) {
        filename = decodeURIComponent(contentDisposition);
      }

      // Create a URL for the Blob
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename); // Use the extracted filename

      // Append to the DOM and trigger download
      document.body.appendChild(link);
      link.click();

      // Clean up
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);

    } catch (error) {
      console.error('Error during document download:', error);
      showWarning('문서 다운로드 중 오류가 발생했습니다.');
    } finally {
      setLoading(false);
    }
  };

  // Download summary item
  const handleDownloadItem = () => {
    // Check if all selected items have progress '완료'
    const allCompleted = selectedItems.every(itemId => {
      const item = summaryDataFetch.find(item => item.id === itemId);
      return item && item.progress === '완료';
    });

    if (!allCompleted) {
      // If any item is not 완료, show warning and do not proceed with download
      showWarning('완료되지 않는 발화나 회의록 선택되었습니다.');
      return;
    }

    const userConfirmed = window.confirm("선택한 음성 요약을 다운로드하시겠습니까?");

    if (userConfirmed) {
      // Sequentially download each item
      downloadDocuments();
    }
  };

  // GET request for retrieve datas 
  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.get('solo_audio');
      // console.log(response?.status);
      if (response?.status === 200) {
        setLoading(false);
        // console.log(response?.data);
        const sortedData = response.data?.uploaded_audios.sort((a, b) => new Date(b.uploaded_date) - new Date(a.uploaded_date));
        setSummaryDataFetch(sortedData);
        setAnalytics([response?.data.todays_login_users_count, response?.data.total_summarized_audio, response?.data.total_visitors])


        // Counting items where progress is not '완료'
        const activeItemsCount = sortedData.reduce((count, item) => {
          return item.progress !== '완료' ? count + 1 : count;
        }, 0);
        setActiveCount(activeItemsCount);

        // Handle successful response, e.g., set some state.
      } else if (response?.data?.detail == 'Unauthenticated!') {
        setLoading(false);
        navigate('/auth/login'); // Use navigate to redirect to the login page.
      } else {
        setLoading(false);
        navigate('/auth/login'); // Use navigate to redirect to the login page.
      }
    } catch (error) {
      if (retryCount < MAX_RETRY_LIMIT) {
        setRetryCount(retryCount + 1);
        // Optionally, you can add a delay here
        // setTimeout(() => fetchData(), RETRY_DELAY);
      } else {
        // Handle max retry limit reached
        setLoading(false);
        navigate('/auth/login');
      }
    }
  };


  useEffect(() => {
    console.log()
    fetchData();
    const interval = setInterval(() => {
      fetchData(); // Call fetchData every 8 seconds
    }, 8000); // 8000 milliseconds = 8 seconds

    return () => clearInterval(interval);
  }, []);


  // Event handle on click Upload Audio and Image
  const handleClickUploadAudioAndPpt = () => {
    //TODO: Post request for generate ID -> 200 response 
    fetchData();
    if (activeCount >= 3) {
      showWarning("현재 3개 음성 파일이 진행중입니다. \n 잠시후 업로드 부탁드립니다.")
    } else {
      navigate('/summary/upload_ppt_audio');
    }
  }

  // Event handle on click Upload Audio
  const handleClickUploadAudio = () => {
    //TODO: Post request for generate ID -> 200 response 
    // fetch data for get latest progres
    fetchData();
    if (activeCount >= 3) {
      showWarning("현재 3개 음성 파일이 진행중입니다. \n 잠시후 업로드 부탁드립니다.")
    } else {
      navigate('/summary/upload_audio');
    }
  }


  const updateButtonStates = () => {
    if (selectedItems.length > 0) {
      setCheckButtonState(true);
    } else {
      setCheckButtonState(false);
    }
  };

  useEffect(() => {
    updateButtonStates();

  }, [selectedItems]);


  // Filter data based on the selected filter option
  const filteredData = summaryDataFetch.filter((item) => {
    if (filterOption === 'all') {
      return true; // Show all data
    }

    const currentDate = new Date();
    const itemDate = new Date(item.uploaded_date);

    if (filterOption === 'day') {
      // Filter for today (starting from 12:00 AM)
      const startOfToday = new Date(currentDate.setHours(0, 0, 0, 0));
      return itemDate >= startOfToday;
    } else if (filterOption === 'week') {
      // Filter by week (7 days)
      const sevenDaysAgo = new Date(
        currentDate.getTime() - 7 * 24 * 60 * 60 * 1000
      );
      return itemDate >= sevenDaysAgo;
    } else if (filterOption === 'month') {
      // Filter by month (30 days)
      const thirtyDaysAgo = new Date(
        currentDate.getTime() - 30 * 24 * 60 * 60 * 1000
      );
      return itemDate >= thirtyDaysAgo;
    } else if (filterOption === 'year') {
      // Filter by year (365 days)
      const oneYearAgo = new Date(
        currentDate.getTime() - 365 * 24 * 60 * 60 * 1000
      );
      return itemDate >= oneYearAgo;
    }

    return true;
  });


  const handleSelectAll = () => {
    const toggleSelectAll = !selectAll;
    setSelectAll(toggleSelectAll);

    if (toggleSelectAll) {
      // Select all items
      const allDocumentIds = summaryDataFetch.map((item) => item.id);
      setSelectedItems(allDocumentIds);
    } else {
      // Unselect all items
      setSelectedItems([]);
    }
  };

  const handleCheckboxChange = (id) => {
    const updatedSelectedItems = [...selectedItems];

    if (updatedSelectedItems.includes(id)) {
      updatedSelectedItems.splice(updatedSelectedItems.indexOf(id), 1);
      console.log(id);
    } else {
      updatedSelectedItems.push(id);
    }

    setSelectedItems(updatedSelectedItems);
    setSelectAll(updatedSelectedItems.length === data.length);
  };

  const handleSearchInputChange = (event) => {
    setSearchInput(event.target.value);
  };

  const handleFilterChange = (event) => {
    const selectedOption = event.target.value;
    setFilterOption(selectedOption);

    // Reset the search input when the filter option changes
    setSearchInput('');
  };

  // Filter data based on the search input and filter option
  const filteredDataWithSearch = filteredData.filter((item) => {
    if (filterOption === '0') {
      return true; // No filter selected, show all data
    }

    if (filterOption === 'type') {
      return item.type
        .toLowerCase()
        .includes(searchInput.toLowerCase());
    } else if (filterOption === 'title') {
      return item.title.toLowerCase().includes(searchInput.toLowerCase());
    }

    return true;
  });

  // change datetime to 년월인
  function getDateTime(uploadedDate) {
    const date = new Date(uploadedDate);
    const year = date.getFullYear();
    const month = date.getMonth() + 1; // Months are zero-based, so add 1
    const day = date.getDate();
    const hours = date.getHours();
    const minutes = date.getMinutes();

    // Use template literals to format the date and time as "YYYY년 MM월 DD일 HH:MM"
    const formattedDateTime = `${year}년 ${month}월 ${day}일 ${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;

    return formattedDateTime;
  }


  // Remove summary item
  const handleRemove = () => {
    // 사용자의 확인을 요청
    const userConfirmed = window.confirm(
      "선택한 음성 발화 삭제하시겠습니까?"
    );

    if (userConfirmed) {
      // 사용자가 확인했으므로 삭제 작업을 진행합니다
      const removePromises = selectedItems.map((item) => removeData(item));

      Promise.all(removePromises)
        .then(() => {
          showSuccessfullyDeleteSummary("음성 발화 성공적으로 삭제되었습니다!");
          setSelectedItems([]);
          setSummaryDataFetch([]);
          fetchData(); // Re-fetch data
        })
        .catch((error) => {
          showErrorDeleteSummary("선택한 음성 발화 삭제가 실패되었습니다!");
          console.error("Error while removing items:", error);
        });
    }
  }

  // set progress
  const getProgressClass = (progress) => {
    if (progress === '실패') {
      return 'badge text-danger bg-danger bg-opacity-15 px-2 py-6px rounded fs-12px d-inline-flex align-items-center';
    } else if (progress === '대기') {
      return 'badge text-black bg-light bg-opacity-15 px-2 py-6px rounded fs-12px d-inline-flex align-items-center';
    } else if (progress === '진행중') {
      return 'badge text-info bg-info bg-opacity-15 px-2 py-6px rounded fs-12px d-inline-flex align-items-center';
    } else {
      return 'badge text-success bg-success bg-opacity-15 px-2 py-6px rounded fs-12px d-inline-flex align-items-center';
    }
  };
  // const getProgressText = (progress) => {
  //   if (progress === -1) {
  //     return '실패';
  //   } else if (progress === 0) {
  //     return '대기';
  //   } else {
  //     return '완료';
  //   }
  // };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredDataWithSearch.slice(indexOfFirstItem, indexOfLastItem);
  const totalPageNumbers = Math.ceil(filteredDataWithSearch.length / itemsPerPage);

  useEffect(() => {
    setCurrentPage(1);
  }, [filterOption, searchInput]);


  // handle open summarization page
  const handleOpenSummary = (item) => {
    const url = `/draft-summary/${item.id}`;
    if (item.progress == '대기') {
      showWarning("대기중입니다")
    } else if (item.progress == '실패') {
      showWarning("실패된 요약입니다")
    }
    else {
      navigate(url);
    }
  }

  // handle change pagination
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      {/* <Instruction /> */}
      <div class="app-content">
        <div className='container-xl'>
          <div className='row'>
            <div className='col-sm-12 col-md-3 order-2 order-md-1' style={{ marginBottom: 15, maxWidth: 400 }}>
              <Info showSuccess={showSuccess} />
              <Analytics analytics={analytics} />
            </div>

            <div className='col-sm-12 col-md order-1 order-md-2'>
              <div className='row'>
                <div className='col-sm-12 col-md-4'>
                  <div className="card mb-3 rounded-3 shadow-lg" onClick={handleClickUploadAudioAndPpt} style={{ minHeight: 180, border: 'none', cursor: 'pointer', backgroundColor: '#5B8DEF' }}>
                    <div className="border-0 rounded">
                      <div className="card-body">
                        <h5 className="mb-0 text-white">[ABM전용] <br /> 제품 자문 회의록 도우미로 <br /> 초안을 빠르게 작성하세요</h5>
                        <div className="d-flex justify-content-center" style={{ width: '100%' }}>
                            <AbmAIAnimation />
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-sm-12 col-md-4'>
                  <div className="card mb-3  rounded-3 shadow-lg" onClick={handleClickUploadAudio} style={{ minHeight: 180, border: 'none', cursor: 'pointer', backgroundColor: '#ef735b' }}>
                    <div className="border-0 rounded">
                      <div class="d-flex align-items-center">
                        <div className="card-body">

                          <h5 className="mb-0 text-white">[모든 회의용] <br /> AI 구간 요약을 통해 <br /> 회의 핵심만 파악하세요</h5>
                          <div className="d-flex justify-content-center" style={{ width: '100%' }}>
                            <AudioAIAnimation />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className='col-sm-12 col-md-4'>
                  <div className="card mb-3 rounded-3 shadow-sm" style={{ minHeight: 180, border: 'none', backgroundColor: '#5dc1b9' }}>
                    <div className="card-body">
                      <h5 className="mb-0 text-white">신규 기능 기획 중 입니다 <br /> 감사합니다</h5>
                      <div className="d-flex justify-content-center" style={{ width: '100%' }}>
                            <ComingSoonAnimation />
                          </div>
                    </div>
                  </div>
                </div> */}
              </div>
              <div class="card mb-3">
                <div class="hljs-container border-0 rounded">
                  {/* <RemoveItemAnimation /> */}
                  <div className="row">
                    <div class="card-body">
                      <div class="row gy-2 gx-2 align-items-center">
                        <div class="col-12 col-md-3 col-xxl-3">
                          <div class="input-group flex-nowrap">
                            <span class="input-group-text" id="addon-wrapping"><i className='fas fa-calendar-alt' /></span>
                            <label class="visually-hidden" for="selApprovalStatus">
                              전체
                            </label>
                            <select
                              class="form-select"
                              id="selApprovalStatus"
                              onChange={handleFilterChange}
                              value={filterOption}
                            >
                              <option value="all">전체</option>
                              <option value="day">오늘</option>
                              <option value="week">이번주</option>
                              <option value="month">이번달</option>
                              <option value="year">올해</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-12 col-md-3 col-xxl-3">
                          <div class="input-group flex-nowrap">
                            <span class="input-group-text" id="addon-wrapping"><i className='fas fa-search' /></span>
                            <label class="visually-hidden" for="selMaterialType">
                              검색 필터
                            </label>
                            <select
                              class="form-select"
                              id="selMaterialType"
                              onChange={handleFilterChange}
                              value={filterOption}
                            >
                              <option value="0">검색 필터</option>
                              <option value="type">분류</option>
                              <option value="title">제목</option>
                            </select>
                          </div>
                        </div>

                        <div id="divMaterialName" class="col-12 col-md-6 col-xxl-6">

                          <label class="visually-hidden" for="materialName">
                            검색
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            id="materialName"
                            placeholder="검색"
                            value={searchInput}
                            disabled={
                              filterOption !== 'type' &&
                              filterOption !== 'title'
                            }
                            onChange={handleSearchInputChange}
                          />
                        </div>

                        <div class="col-6 col-md-2 col-xxl-2"></div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    {/* <div class="tab-content p-4">
                    <div className="mb-0 justify-content-center flex-wrap text-end">
                      <div className="btn-group">
                        <button
                          className="btn btn-primary ml-auto dropdown-toggle"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <i className="fas fa-lg fa-fw me-2 fa-plus"></i> 파일 업로드하기
                        </button>
                        <ul className="dropdown-menu">
                          <li><a className="dropdown-item" onClick={handleClickUploadAudio}>음성 요약</a></li>
                          <li ><a className="dropdown-item" onClick={handleClickUploadAudioAndPpt}>ABM 회의록</a></li>
                        </ul>
                      </div>
                    </div>
                  </div> */}
                    {/* </div>summaryDataFetch */}
                    {/* Show summary datas */}
                    <>

                      <div class="table-responsive">
                        <table class="table table-hover text-nowrap">
                          <thead>
                            <tr>
                              <th class="border-top-0 pt-0 pb-2">
                                <div class="form-check">
                                  <input
                                    type="checkbox"
                                    class="form-check-input"
                                    id="selectAll"
                                    checked={selectAll}
                                    onChange={handleSelectAll}
                                  />
                                  <label class="form-check-label" for="selectAll"></label>
                                </div>
                              </th>
                              <th class="border-top-0 pt-0 pb-2">등록일자</th>
                              <th class="border-top-0 pt-0 pb-2">분류</th>
                              <th class="border-top-0 pt-0 pb-2">제목</th>
                              <th class="border-top-0 pt-0 pb-2" style={{ maxWidth: 70 }}>음성파일 변환</th>
                            </tr>
                          </thead>
                          <tbody>

                            {filteredDataWithSearch.length > 0 ? (
                              currentItems.map((item) => (
                                <tr key={item.id}>
                                  <td className="w-10px align-middle">
                                    <div className="form-check">
                                      <input
                                        type="checkbox"
                                        checked={selectedItems.includes(item.id)}
                                        className="form-check-input"
                                        id={item.id}
                                        onChange={() => handleCheckboxChange(item.id)}
                                      />
                                      <label className="form-check-label" htmlFor={item.id}></label>
                                    </div>
                                  </td>
                                  <td style={{ userSelect: 'none' }} onClick={() => handleOpenSummary(item)} className="align-middle">
                                    {getDateTime(item.uploaded_date)}
                                  </td>
                                  <td style={{ userSelect: 'none' }} onClick={() => handleOpenSummary(item)} className="align-middle">
                                    {item.type}
                                  </td>
                                  <td style={{ userSelect: 'none' }} onClick={() => handleOpenSummary(item)}>
                                    {item.title}
                                  </td>
                                  <td className="py-1 align-middle" style={{ maxWidth: 70, userSelect: 'none' }}>
                                    <span className={getProgressClass(item.progress)}>
                                      <i className="fa fa-circle fs-9px fa-fw me-5px"></i> {item.progress}
                                    </span>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={5} className="text-center">
                                  업로드된 데이터가 없습니다!
                                </td>
                              </tr>
                            )}
                            {/* {filteredDataWithSearch.length > 0 ? (
                        filteredDataWithSearch.map((item) => (
                          <tr key={item.id}>
                            <td className="w-10px align-middle">
                              <div className="form-check">
                                <input
                                  type="checkbox"
                                  checked={selectedItems.includes(item.id)}
                                  className="form-check-input"
                                  id={item.id}
                                  onChange={() => handleCheckboxChange(item.id)}
                                />
                                <label className="form-check-label" htmlFor={item.id}></label>
                              </div>
                            </td>
                            <td style={{ userSelect: 'none' }} onClick={() => navigate(`/draft-summary/${item.id}`)} className="align-middle">
                              {getDateTime(item.uploaded_date)}
                            </td>
                            <td style={{ userSelect: 'none' }} onClick={() => navigate(`/draft-summary/${item.id}`)} className="align-middle">
                              {item.type}
                            </td>
                            <td style={{ userSelect: 'none' }} onClick={() => navigate(`/draft-summary/${item.id}`)}>
                              {item.title}
                            </td>
                            <td className="py-1 align-middle" style={{ maxWidth: 70, userSelect: 'none' }}>
                              <span className={getProgressClass(item.progress)}>
                                <i className="fa fa-circle fs-9px fa-fw me-5px"></i> {item.progress}
                              </span>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={5} className="text-center">
                            업로드된 데이터가 없습니다!
                          </td>
                        </tr>
                      )} */}
                          </tbody>
                        </table>
                      </div>
                    </>


                    <div class="d-lg-flex align-items-center">
                      <div class="me-lg-auto text-md-left text-center mt-2 mt-lg-0 mb-2 mb-lg-0">
                        <div class="ms-auto btn-group">
                          <button
                            onClick={() => handleDownloadItem()}
                            class="btn btn-default btn-sm"
                            disabled={selectedItems.length == 0}
                          >
                            <i class="fas fa-fw  fa-download"></i>
                          </button>
                          <button
                            onClick={() => handleRemove()}
                            class="btn btn-default btn-sm"
                            disabled={selectedItems.length == 0}
                          >
                            <i class="fa fa-fw fa-trash"></i>
                          </button>
                        </div>
                      </div>
                      {/* <div className="mb-0 justify-content-center flex-wrap">
                Showing 1 to 10 of 57 entries
              </div> */}
                      <ul className="pagination">
                        {[...Array(totalPageNumbers)].map((e, i) => (
                          <li key={i} className={`page-item ${i + 1 === currentPage ? 'active' : ''}`}>
                            <a onClick={() => handlePageChange(i + 1)} className="page-link">
                              {i + 1}
                            </a>
                          </li>
                        ))}
                      </ul>
                      {/* <select value={itemsPerPage} onChange={(e) => setItemsPerPage(Number(e.target.value))}>
                  {[10, 20, 30].map((number) => (
                    <option key={number} value={number}>
                      Show {number}
                    </option>
                  ))}
                </select> */}
                    </div>
                  </div>
                </div>
              </div >
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Summary;
